"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.HeaderWrapper = exports.BackIconButton = exports.PageContent = exports.Container = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
exports.Container = styled_components_1.default.section `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  height: 100%;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    height: 100vh;
  }
`;
exports.PageContent = styled_components_1.default.div(({ paddingTop, paddingBottom, paddingLeft, paddingRight }) => (0, styled_components_1.css) `
    position: relative;
    padding: ${paddingTop}px ${paddingLeft}px ${paddingBottom}px ${paddingRight}px;
  `);
exports.BackIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  margin-right: 10px;
  padding: 6px;
`;
exports.HeaderWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
exports.Header = (0, styled_components_1.default)(material_1.Typography) `
  font-size: 20px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    font-size: 33px;
  }
`;
